<template>
    <div class="discuss-create-page">
        <!-- 1. 标题 -->
        <title-bar
            v-bind:titleData="titleData"
            v-bind:backFunc="clickBack">
        </title-bar>

        <!-- 2. 输入框 -->
        <div class="discuss-create-content">
            <div class="discuss-create-line">
                <span class="discuss-create-title">主  题：</span>
                <input class="discuss-create-input" v-model="titleValue" placeholder="输入论盘主题" maxlength="20" type="text">
            </div>
            <div class="discuss-create-textarea-box">
                <textarea class="discuss-create-textarea" v-model="desValue" placeholder="内容交待:可为空" name="" id="" cols="30" rows="10"></textarea>
            </div>
            <div class="discuss-create-select-box dsp-flex">
                <div class="discuss-create-select-left" @click="togglePublic">
                    <i class="iconfont " v-bind:class="{'icon-selected': selectPublic, 'icon-unselected': !selectPublic}"></i>同时发布到公共论盘区
                </div>
                <div class="discuss-create-select-right" @click="toggleAnony">
                    <i class="iconfont " v-bind:class="{'icon-selected': selectAnony, 'icon-unselected': !selectAnony}"></i>命盘显示匿名
                </div>
            </div>
        </div>

        <!-- 3. 创建按钮 -->
        <div class="famous-pedia-bottom-bar" @click="clickStartDiscuss">
            <div class="famous-pedia-btn-start famous-pedia-btn-start-2">发起论盘</div>
        </div>
    </div>
</template>

<script>

import TitleBar from '../../components/TitleBar.vue'
import { DISCUSS_DOM } from '../../modules/dom';
import { SHARE } from '../../modules/share';
import { WS } from '../../modules/websocket';
export default {
    name: 'DiscussCreate',
    components: { TitleBar },
    computed: {

    },
    data() {
        return {
            titleData: {'titleText': '发起论盘', 'showCancel': false},
            titleValue: '',
            desValue: '',
            selectPublic: true,
            selectAnony: true
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            var contentDiv = document.getElementsByClassName('discuss-create-content')[0],
                bottomDiv = document.getElementsByClassName('famous-pedia-bottom-bar')[0];
            if(contentDiv) {
                contentDiv.style.height = (innerHeight - bottomDiv.clientHeight) + 'px';
            }
        },
        clickBack() {
            this.$router.go(-1);
        },
        togglePublic() {
            this.selectPublic = !this.selectPublic;
        },
        toggleAnony() {
            this.selectAnony = !this.selectAnony;
        },
        clickStartDiscuss() {
            // 主题不能为空
            if(this.titleValue == '') {
                this.$toast('请填写主题哟~');
                return;
            }
            // console.error('clickStartDiscuss------', this.titleValue, this.desValue)
            var me = this,
                personInfo = this.$store.state.detail.personInfo;
            this.$store.state.discuss.detailInfo = personInfo;
            this.$store.dispatch('discuss/addNewLunPan', {
                params: {
                    lunpanName: this.titleValue,
                    lunpanDes: this.desValue,
                    public: this.selectPublic,
                    anony: this.selectAnony
                },
                cb: function(data){
                    setTimeout(() => {
                        me.goToDiscussPage(data);
                    }, 100);
                }
            });
        },
        goToDiscussPage(data) {
            var me = this,
                personInfo = this.$store.state.detail.personInfo;
            // 先重置，再初始化mini命盘的数据
            this.$store.dispatch("minifatefortune/resetMiniData");
            this.$store.dispatch('minifatefortune/initCommentMiniFateFortune', personInfo);
            // 跳转到论盘详情页面
            this.$router.replace('/discuss/discusslist/' + personInfo.id);
            // 初始化IM
            WS.initWebSocket(data.rid, function(){
                // 初始化论盘数据:聊天记录列表:websocket登录之后再拉取列表数据
                me.$store.dispatch("discuss/initLunPan", {
                    lunpanData: data,
                    cb: function() {
                        // 设置微信分享配置
                        setTimeout(() => {
                            me.$bus.emit('initDiscussHistoryList');
                            DISCUSS_DOM.updateDiscussPageStyle();
                            DISCUSS_DOM.updateDiscussFormStyle();
                        }, 200);
                        setTimeout(() => {
                            me.$bus.emit('scrollToDiscussBottom');
                            me.$bus.emit('checkDiscussBubbleStatus');
                        }, 1000);
                    }
                });
            });            
            
            this.$store.state.discuss.lunpanData = data;
            // 配置微信分享
            setTimeout(() => {
                if(!me.fromEmbedded){
                    SHARE.initConfigShare();
                }
            }, 20);
        }
    }
}
</script>